// extracted by mini-css-extract-plugin
export default {"screen":"SideModal_screen__KPgbJ","modalPanel":"SideModal_modalPanel__+nebc","header":"SideModal_header__wEeKz","main":"SideModal_main__BX2cc"};